module.exports = __webpack_public_path__ + "static/media/Air Asia_3_Calendar.507ec505.jpg";